import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.Librarian;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "Librarian.Phaser.IntroductionScene.1",
            "Librarian.Phaser.IntroductionScene.2",
            "Librarian.Phaser.IntroductionScene.3",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/LibrarianGame/scenes/GameIntro.ts